// extracted by mini-css-extract-plugin
export var errorsContainer = "_si-1";
export var link = "_si-0";